import { resizeObservers as r } from "../utils/resizeObservers.js";
var n = function() {
  return r.some(function(e) {
    return e.activeTargets.length > 0;
  });
};
export {
  n as hasActiveObservations
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/algorithms/hasActiveObservations.js
// module id = 1356
// module chunks = 67